import { Constants } from "@eagerdog/constants";
import { IShow } from "@eagerdog/interfaces";
import { IEventRegisterRow } from "../../../services/helper.service.js";

/**
 * C-WAGS FEO (For Exhibition Only) registration row for the show-wide FEO show types
 * (Scent, Games). Rendered directly under the regular row of the same element:
 *
 *   Scent        [ ] Patrol 1      [ ] Detective 2 ...
 *   Scent FEO    [ ] Patrol 1 FEO  [ ] Detective 2 FEO ...
 *
 * `label` stays the real show_element and each option's `id` stays the real level so every
 * show_element / judge / running-time lookup keeps working; the row's fixed `section`
 * ("FEO") is what distinguishes the class (dog_class.section) and drives the flat FEO price.
 */
export const buildCwagsFeoRow = (
  show: IShow | undefined,
  element: string,
  options: Array<{ value: string; id: string }>
): IEventRegisterRow | undefined => {
  if (!show?.feo_available || options.length === 0) {
    return undefined;
  }

  return {
    inputs: [{
      type: "checkbox",
      multiSelect: true,
      label: element,
      displayLabel: `${element} ${Constants.dog_class_section.feo}`,
      section: Constants.dog_class_section.feo,
      options: options.map((o) => ({ id: o.id, value: `${o.value} ${Constants.dog_class_section.feo}` })),
    }],
  };
};
